import { render, staticRenderFns } from "./BrandsSearch.vue?vue&type=template&id=1be7eab7&scoped=true"
import script from "./BrandsSearch.vue?vue&type=script&lang=js"
export * from "./BrandsSearch.vue?vue&type=script&lang=js"
import style0 from "./BrandsSearch.vue?vue&type=style&index=0&id=1be7eab7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be7eab7",
  null
  
)

export default component.exports